import axios from "axios";
import { axiosConfig } from "../../config/index";
import fileDownload from "js-file-download";

import { EXPORT_REQUESTS_BY_STATUS, EXPORT_REQUESTS_BY_STATUS_DATERANGE, EXPORT_REQUESTS_BY_TYPE, EXPORT_REQUESTS_BY_TYPE_DATERANGE, REQUESTS_BY_STATUS, REQUESTS_BY_TYPE, UNIFIED_REPORT, EXPORT_UNIFIED_REPORT, SERVER_ERRORS } from "../types";
import dayjs from "dayjs";

export const getRequestsByStatus = (status: string) => (dispatch: any) => {
  axios.get(`/api/report/requestStatus/${status}`, axiosConfig).then(res => {
    dispatch({ type: REQUESTS_BY_STATUS, requestsByStatus: res.data });
  }).catch(err => {
    console.error(err);
  });
};

export const getRequestsByType = (requesttype: string) => (dispatch: any) => {
  axios.get(`/api/report/type/${requesttype}`, axiosConfig).then(res => {
    dispatch({ type: REQUESTS_BY_TYPE, requestsByType: res.data });
  }).catch(err => {
    console.error(err);
  });
};

export const getUnifiedReport = (filters: any) => (dispatch: any) => {
  const params = new URLSearchParams(filters).toString();
  axios.get(`/api/report/unified?${params}`, axiosConfig).then(res => {
    dispatch({ 
      type: UNIFIED_REPORT, 
      reportData: res.data.requests,
      totalRequests: res.data.totalCount 
    });
  }).catch(err => {
    console.error(err);
  });
};

export const exportRequestByStatus = (
  status: string) => (dispatch: any, getState: any) => {
    const fileName =
      status + "Requests" + dayjs().format("YYYYMMDDHHmmss") + ".csv";
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/report/export/${status}`,
          axiosConfig
        )
        .then(res => {
          dispatch({
            type: EXPORT_REQUESTS_BY_STATUS
          });
          fileDownload(res.data, fileName);
          resolve(true);
        })
        .catch(err => {
          dispatch({
            type: SERVER_ERRORS,
            errors: err.response.data
          })
          reject(err.response.data)
        });
    });
  };

export const exportRequestByType = (
  requesttype: string) => (dispatch: any, getState: any) => {
    const fileName =
      requesttype + "Requests" + dayjs().format("YYYYMMDDHHmmss") + ".csv";
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/report/exportbytype/${requesttype}`,
          axiosConfig
        )
        .then(res => {
          dispatch({
            type: EXPORT_REQUESTS_BY_TYPE
          });
          fileDownload(res.data, fileName);
          resolve(true);

        })
        .catch(err => {
          dispatch({
            type: SERVER_ERRORS,
            errors: err.response.data

          })
          reject(err.response.data)
        });
    });
  };
export const exportRequestByTypeWithDateRange = (
  requesttype: string,
  { startdate, enddate }: any) => (dispatch: any, getState: any) => {
    const fileName =
      requesttype + "Requests" + dayjs().format("YYYYMMDDHHmmss") + ".csv";
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/report/exportbytype/${requesttype}/${startdate}/${enddate}`,
          axiosConfig
        )
        .then(res => {
          dispatch({
            type: EXPORT_REQUESTS_BY_TYPE_DATERANGE
          });
          fileDownload(res.data, fileName);
          resolve(true);

        })
        .catch(err => {
          dispatch({
            type: SERVER_ERRORS,
            errors: err.response.data

          })

          reject(err.response.data)

        });
    });
  };
export const exportRequestByStatusWithDateRange = (
  status: string,
  { startdate, enddate }: any) => (dispatch: any, getState: any) => {
    const fileName =
      status + "Requests" + dayjs().format("YYYYMMDDHHmmss") + ".csv";
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/report/export/${status}/${startdate}/${enddate}`,
          axiosConfig
        )
        .then(res => {
          dispatch({
            type: EXPORT_REQUESTS_BY_STATUS_DATERANGE
          });
          fileDownload(res.data, fileName);
          resolve(true);

        })
        .catch(err => {
          dispatch({
            type: SERVER_ERRORS,
            errors: err.response.data

          })

          reject(err.response.data)

        });
    });
  };

export const exportUnifiedReport = (filters: any) => (dispatch: any) => {
  const params = new URLSearchParams(filters).toString();
  const fileName = "UnifiedReport_" + dayjs().format("YYYYMMDDHHmmss") + ".csv";
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/report/exportUnified?${params}`, axiosConfig)
      .then(res => {
        dispatch({ type: EXPORT_UNIFIED_REPORT });
        fileDownload(res.data, fileName);
        resolve(true);
      })
      .catch(err => {
        const errorMsg = err.response?.data?.error || "Failed to export report";
        dispatch({ type: SERVER_ERRORS, errors: errorMsg });
        reject(errorMsg);
      });
  });
};






